import { TextField, Autocomplete } from "@mui/material";
import type { SyntheticEvent } from "react";
import type { KeySelectChangedHandler, KeyValueOption } from "../../../types";

const waterTestStatusOptions: KeyValueOption[] = [
  { key: 1, value: "実施済み" },
  { key: 2, value: "業者依頼中" },
  { key: 0, value: "未実施" },
];

type WaterTestStatusSelectProps = {
  waterTestStatus?: number | string | null;
  changedValue: KeySelectChangedHandler;
};

export default function WaterTestStatusSelect({
  waterTestStatus,
  changedValue,
}: WaterTestStatusSelectProps) {
  const handleChange = (
    _event: SyntheticEvent,
    newValues: KeyValueOption | null,
  ) => {
    changedValue(newValues ? newValues.key : null);
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={waterTestStatusOptions}
      getOptionLabel={(sale) => sale.value}
      isOptionEqualToValue={(option, value) => option.key === value.key}
      value={
        waterTestStatusOptions.find(
          (status) => status.key === waterTestStatus,
        ) || null
      }
      renderInput={(params) => (
        <TextField {...params} name="waterTestStatusSelect" />
      )}
      onChange={handleChange}
    />
  );
}
